class PaginationControl extends window.BAO.CustomElement({
  SuperClass: HTMLDivElement,
}) {
  constructor () {
    super()

    switch (this.dataset.type) {
      case 'search':
        this.eventBus = window.theme.searchResults.eventBus
        this.state = {
          root: window.theme.searchResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      case 'autocomplete':
        this.eventBus = window.theme.autocompleteResults.eventBus
        this.state = {
          root: window.theme.autocompleteResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      default:
        // Default is collection
        this.eventBus = window.theme.category.eventBus
        this.state = {
          root: window.theme.category?.stateLayer?.state || { products: [] },
          observer: null,
        }
    }
  }

  connectedCallback () {
    this.subscribeToEvents()
    this.setupListeners()
  }

  subscribeToEvents () {
    // Update pagination controls when total products change OR when pagination state changes
    const updatePaginationControls = () => {
      if (this.offset + this.limit >= this.totalProducts) {
        this.els.count.element.textContent = `${this.totalProducts} of ${this.totalProducts} products`
      } else {
        this.els.count.element.textContent = `${this.offset + this.limit} of ${
          this.totalProducts
        } products`
      }

      if (this.totalProducts < window.theme.collection.limit) {
        this.els['load-more-button'].element.setAttribute('hidden', '')
        this.els['load-preview-button'].element.setAttribute('hidden', '')
        this.els.count.element.setAttribute('hidden', '')
        this.els.progress.element.setAttribute('hidden', '')
      } else {
        this.els['load-more-button'].element.removeAttribute('hidden')
        this.els['load-preview-button'].element.removeAttribute('hidden')
        this.els.count.element.removeAttribute('hidden')
        this.els.progress.element.removeAttribute('hidden')
      }

      this.els.progress.element.style.setProperty(
        '--ProductCount',
        this.offset + this.limit,
      )
      this.els.progress.element.style.setProperty(
        '--TotalCount',
        this.totalProducts,
      )

      if (this.offset + this.limit >= this.totalProducts) {
        this.els['load-more-button'].element.setAttribute('hidden', '')
      } else {
        this.els['load-more-button'].element.removeAttribute('hidden')
      }

      if (this.currentPage > 1) {
        this.els['load-preview-button'].element.removeAttribute('hidden')
      } else {
        this.els['load-preview-button'].element.setAttribute('hidden', '')
      }
    }

    this.eventBus.subscribe(
      'state:totalProducts:updated',
      updatePaginationControls,
    )
    this.eventBus.subscribe(
      'state:pagination:updated',
      updatePaginationControls,
    )
  }

  setupListeners () {
    this.els['load-more-button'].element.addEventListener('click', () => {
      if (
        window.location.hash &&
        window.location.hash.startsWith('#product-')
      ) {
        window.history.replaceState(
          null,
          document.title,
          window.location.pathname + window.location.search,
        )
      }

      if (
        window.location.hash &&
        (window.location.hash.startsWith('#product-') ||
          window.location.hash.startsWith('#wishlist-'))
      ) {
        window.location.hash = ''
      }

      this.eventBus.publish('pagination:control:load-more')
    })

    this.els['load-preview-button'].element.addEventListener('click', () => {
      if (
        window.location.hash &&
        window.location.hash.startsWith('#product-')
      ) {
        window.history.replaceState(
          null,
          document.title,
          window.location.pathname + window.location.search,
        )
      }

      if (
        window.location.hash &&
        (window.location.hash.startsWith('#product-') ||
          window.location.hash.startsWith('#wishlist-'))
      ) {
        window.location.hash = ''
      }

      this.eventBus.publish('pagination:control:load-previous')
    })
  }

  get currentPage () {
    return this.state.root?.pagination?.currentPage
  }

  get totalProducts () {
    return this.state.root.totalProducts
  }

  get offset () {
    return this.state.root?.pagination?.offset || 0
  }

  get limit () {
    return Number(window.theme.collection.limit)
  }
}

customElements.define('pagination-control', PaginationControl, {
  extends: 'div',
})
